import {microreelsListText} from './microreelsListText';

export const groupPosterText = {
  heading: microreelsListText.groupPosterHeading,
  replace: microreelsListText.posterReplace,
  remove: microreelsListText.posterRemove,
  emptyTitle: microreelsListText.posterEmptyTitle,
  emptyHint: microreelsListText.posterGroupEmptyHint,
  hint: microreelsListText.groupPosterHint,
  hintEmpty: microreelsListText.groupPosterEmptyHint,
};
